<template>
    <div>
        <div class="bg-light p-3 justify-content-around d-none d-lg-inline">
            <b-row align-h="between">
                <!-- <b-row class="pb-4">
                <b-col class="ml-4">
                    <app-btn-home />
                </b-col>
                <b-col>
                    <app-btn-back />
                </b-col>
            </b-row> -->
                <b-row class="pb-4 pl-4 no-gutters">
                    <b-col class="mx-1">
                        <app-btn-home />
                    </b-col>
                    <b-col class="mx-0">
                        <app-btn-back />
                    </b-col>
                </b-row>
                <b-col class="d-flex justify-content-center mr-4">
                    <b-row align-h="center" class="align-items-center">
                        <b-col cols="auto" :title="currentClient.name" v-if="!!currentClient"
                            ><i class="fas fa-handshake mr-2"></i> {{ currentClient.name | elipsis(40) }}</b-col
                        >
                        <!-- <b-col cols="auto" :title="currentUnit.name" v-if="!!currentUnit"
                        ><i class="fas fa-city mr-2"></i> {{ currentUnit.name | elipsis(40) }}</b-col
                    > -->
                        <b-col cols="auto" :title="currentVenue.name" v-if="!!currentVenue"><i class="fas fa-building mr-2"></i> {{ currentVenue.name }}</b-col>
                        <b-col cols="auto" v-if="!!currentProfile"><i class="fas fa-user-circle mr-2"></i> {{ currentProfile.name }}</b-col>
                        <!-- <b-col cols="auto" v-if="['vigilante'].includes(currentProfile.slug) && guardNotifications.length > 0">
                            <b-dropdown
                                ref="notificationsDropdown"
                                size="lg"
                                variant="link"
                                toggle-class="text-decoration-none"
                                no-caret
                                class="position-relative"
                            >
                                <template #button-content class="bg-light text-primary cursor-pointer">
                                    <i class="far fa-bell"></i
                                    ><span class="badge rounded-pill bg-danger top-0 position-absolute"> {{ guardNotifications.length }} </span>
                                </template>
                                <b-dropdown-text
                                    v-for="notification in guardNotifications"
                                    :value="notification"
                                    :key="notification.id"
                                    @click="goToNotification(notification.route, notification.id)"
                                    style="cursor: pointer"
                                    >{{ notification.title }}</b-dropdown-text
                                >
                            </b-dropdown>
                        </b-col> -->
                    </b-row>
                </b-col>
                <div class="d-flex justify-content-end align-items-center mr-4">
                    <app-more-services style="margin-right: 10px">
                    </app-more-services>
                    <app-admin-settings v-if="currentProfile.slug == 'administrador' || currentProfile.slug == 'administrativo'" style="margin-right: 10px">
                    </app-admin-settings>
                    <app-user-menu style="margin-right: 10px" @logout="$emit('logout')" @profile="$router.push({ name: 'userAccount' })"></app-user-menu>
                </div>
            </b-row>
        </div>
        <div class="d-md-none pr-3" v-if="['vigilante'].includes(currentProfile.slug) && guardNotifications.length > 0">
            <div class="d-flex justify-content-end">
                <b-dropdown ref="notificationsDropdown" size="lg" variant="link" toggle-class="text-decoration-none" no-caret class="position-relative">
                    <template #button-content class="bg-light text-primary cursor-pointer">
                        <i class="far fa-bell"></i><span class="badge rounded-pill bg-danger top-0 position-absolute"> {{ guardNotifications.length }} </span>
                    </template>
                    <b-dropdown-group
                        v-for="notification in guardNotifications"
                        :value="notification"
                        :key="notification.id"
                        id="dropdown-group-1"
                        @click="goToNotification(notification.route, notification.id)"
                        :header="notification.title"
                    >
                        <b-dropdown-text style="cursor: pointer; width: 240px">{{ notification.body.substring(0, 100) }}</b-dropdown-text>
                    </b-dropdown-group>
                </b-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import appUserMenu from './UserMenu'
import appAdminSettings from './AdminSettings'
import appMoreServices from './MoreServices.vue'
import { SET_GUARD_NOTIFICATIONS } from '@store/_mutations'
import { mapGetters, mapMutations } from 'vuex'
export default {
    components: {
        appUserMenu,
        appAdminSettings,
        appMoreServices,
    },
    computed: {
        ...mapGetters({
            guardNotifications: 'guardNotifications',
        }),
    },
    methods: {
        ...mapMutations({
            setGuardNotifications: SET_GUARD_NOTIFICATIONS,
        }),
        async goToNotification(route, id) {
            try {
                const payload = {
                    currentUserId: this.currentUserId,
                    isRead: 1,
                }
                const { data } = await this.$repo.put(`notifications/${id}`, payload)

                const notifications = this.guardNotifications.filter((notification) => notification.id !== id)
                this.setGuardNotifications(notifications)
                this.$refs.notificationsDropdown.hide()

                // validate if the current route is the same as the notification route
                if (this.$route.name === route) return
                this.$router.push({ name: route })
            } catch (error) {
                toastr.error(error)
            }
            //limpiar el store de notificaciones
        },
    },
}
</script>
